/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Deletedat1Inputs */

const en__field_deletedat1 = /** @type {(inputs: _Field_Deletedat1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deleted at`)
};

/**
* | output |
* | --- |
* | "Deleted at" |
*
* @param {_Field_Deletedat1Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const _field_deletedat1 = /** @type {((inputs?: _Field_Deletedat1Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Deletedat1Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en__field_deletedat1(inputs)
});
export { _field_deletedat1 as "_field_deletedAt" }